import { render } from "./ApiKeyForm.vue?vue&type=template&id=57f8c430&ts=true"
import script from "./ApiKeyForm.vue?vue&type=script&lang=ts"
export * from "./ApiKeyForm.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__